import { DataService } from "@/services/data";
import { handle_error, handle_success } from "@/utils/wretch";

/**
 * Generic action handler for RelatedListTab CRUD operations.
 *
 * Routes all CRUD through /crm/objects/<child_object_url>/form-action/.
 *
 * Handles actions submitted by DynamicRelatedListContent / EditableRelatedList:
 *   - ?action=related-list-create  (form create submission)
 *   - ?action=related-list-update  (form update submission)
 *   - ?action=delete-related-list  (delete button — EditableRelatedList convention: "delete-{actionPrefix}")
 */
export async function handleRelatedListAction(request: Request): Promise<Response | null> {
    const url = new URL(request.url);
    const action = url.searchParams.get("action");

    if (action !== "related-list-create" && action !== "related-list-update" && action !== "delete-related-list") {
        return null;
    }

    const body = await request.json();

    try {
        const childObjectUrl = body.__childObjectUrl as string;
        const formActionUrl = `/crm/objects/${childObjectUrl}/form-action/`;

        if (action === "related-list-create") {
            const { __childObjectUrl: _, __parentIdField, __parentId, ...data } = body as Record<string, any>;
            const fields = __parentIdField ? { ...data, [__parentIdField]: __parentId } : data;
            return handle_success(
                await DataService.client.url(formActionUrl).post({ action_type: "__create__", fields }).json()
            );
        }

        if (action === "related-list-update") {
            const { __childObjectUrl: _, id, ...data } = body as Record<string, any>;
            return handle_success(
                await DataService.client.url(formActionUrl).post({ action_type: "__update__", id, fields: data }).json()
            );
        }

        if (action === "delete-related-list") {
            const { id } = body as Record<string, any>;
            return handle_success(
                await DataService.client.url(formActionUrl).post({ action_type: "__delete__", id }).json()
            );
        }

        return null;
    } catch (e) {
        return handle_error(e);
    }
}
